<template>
  <div class="position-relative" id="subheader">
    <b-container fluid class="px-4">
      <b-row align-v="center" no-gutters class="amseu-header">
        <!-- Logo -->
        <b-col cols="auto" class="p-0">
          <div class="d-flex align-items-center text-decoration-none amseu-brand">
            <img
              :src="require('@/assets/img/logo/logo_amseu.svg')"
              alt=""
              class="img img-fluid amseu-logo"
            />
            <span class="amseu-title d-none d-sm-flex flex-column ml-3">
              <span class="amseu-title-main">{{ translations[16261] }}</span>
              <span class="amseu-title-sub">{{ translations[16262] }}</span>
            </span>
          </div>
        </b-col>
        <!-- /Logo -->

        <!-- Consultant actions — on the cabinet page they sit here instead of in a separate
             bar above the embedded portal, which took up a whole grey strip of height.
             Phones: own row under logo + language, so the first row matches the public pages. -->
        <b-col
          v-if="showConsultantActions"
          cols="12"
          xl="auto"
          class="d-flex align-items-center justify-content-end order-last order-xl-0 ml-xl-auto pb-2 pb-xl-0"
        >
          <span v-if="consultantName" class="text-muted mr-3 amseu-consultant-name">
            <b-icon aria-hidden="true" icon="person-circle" scale="0.9" class="mr-1" />
            {{ consultantName }}
          </span>
          <b-button :to="portalEntryPath" variant="primary" size="sm" class="mr-2">
            {{ translations[13569] }}
          </b-button>
          <b-button variant="primary" size="sm" @click.prevent="logOutConsultant()">
            <b-icon aria-hidden="true" icon="box-arrow-right" class="mr-1" />
            Logout
          </b-button>
        </b-col>
        <!-- /Consultant actions -->

        <!-- Cooperation -->
        <b-col
          cols="auto"
          class="d-none d-md-flex flex-column align-items-end amseu-coop"
          :class="showConsultantActions ? 'ml-auto ml-xl-4' : 'ml-auto'"
        >
          <span class="amseu-coop-label">IN KOOPERATION MIT</span>
          <img
            :src="require('@/assets/img/logo/mini_logo_amseu.png')"
            alt="EURES"
            class="img img-fluid amseu-coop-logo mt-1"
          />
        </b-col>
        <!-- /Cooperation -->

        <b-col cols="auto" class="d-flex align-items-center ml-auto ml-md-3">
          <language-header />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';

@Component({
  components: {
    LanguageHeader,
  },
})
export default class InformationNavigation extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return AppModule.language;
  }

  // Only inside the consultant cabinet — public pages and the applicant cabinet share this header
  get showConsultantActions() {
    return this.$route.path === '/cabinet' && !!UserModule.accessTokenConsultant;
  }

  get consultantName() {
    const consultant = UserModule.userInfoConsultant?.consultant;
    if (!consultant) return '';
    return [consultant.firstname, consultant.lastname].filter(Boolean).join(' ').trim();
  }

  // Same target as the cabinet bar: amseu has no /workers page when the applicants counter is hidden
  get portalEntryPath() {
    const isApplicantsPageVisible = (AppModule.settingPortal.counters || [])
      .find((counter) => counter.name === 'applicants')?.visible;
    return isApplicantsPageVisible ? '/workers' : '/';
  }

  logOutConsultant() {
    UserModule.LogOutConsultant(AppModule.sid);
    this.$router.push({ name: 'Jobs', query: { lang: AppModule.language } }).catch(() => ({}));
  }
}
</script>
<style scoped lang="scss">
.amseu-header {
  min-height: 4.5rem;
}

.amseu-logo {
  max-height: 3.25rem;
  width: auto;
}

.amseu-title-main {
  color: #ed1639;
  font-weight: 700;
  font-size: 1.375rem;
  line-height: 1.2;
}

.amseu-title-sub {
  color: #4d606a;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.2;
}

.amseu-coop {
  &-label {
    color: #5a6b75;
    font-weight: 700;
    font-size: 10px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  &-logo {
    max-height: 2.25rem;
    width: auto;
  }
}

// Needs room next to the buttons, the cooperation logo and the language switch —
// below 1400px the language switch would wrap onto a second line.
.amseu-consultant-name {
  display: none;
}

@media (min-width: 1400px) {
  .amseu-consultant-name {
    display: inline;
  }
}

@media (max-width: 1199.98px) {
  .amseu-title-main {
    font-size: 1.125rem;
  }
  .amseu-title-sub {
    font-size: 0.8125rem;
  }
}
</style>
